<template>
    <div class="row">
        <b-modal
            id="modalVerAvance"
            scrollable
            title="Avance Partida"
            title-class="font-18"
            size="lg"
            hide-footer
        >
          <PartidaAvanceInfo :data="partida_avance" />
        </b-modal>
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12">
                    <dl class="row mb-0 font-size-14">
                      <!--
                        <dt class="col-sm-4">ID</dt>
                        <dd class="col-sm-8">: {{data.partida_id}}</dd>

                        <dt class="col-sm-4">Partida</dt>
                        <dd class="col-sm-8">: {{data.partida}}</dd>
                      -->
                    </dl>
                </div>

            </div>

            <div class="row font-size-12">
                <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th class="col-md-1" >Fecha</th>
                        <th>Partida</th>
                        <th>UM</th>
                        <th>Cantidad final</th>
                        <th >Costo unitario</th>
                        <th>Parcial final</th>
                        <!--<th>Estado</th>-->
                        <th>Estado</th>
                        <th>Info</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(data,index) in data.partidas" >
                        <tr  v-bind:key="index" :class="{'table-light': index % 2 === 0 }">
                          <td>{{ data.avance_id }}</td>
                          <td>{{data.fecha}}</td>
                          <td>{{data.partida}}</td>
                          <td>{{data.unidad_medida}}</td>
                          <td>
                            <div v-if="parseInt(data.estado)!==3" >
                              {{data.cantidad_corregida}}
                            </div>
                            <div class="input-group input-group-sm" v-if="parseInt(data.estado)===3 && data.tipo_costo==='Costo directo'">
                              <input
                                  type="text" class="form-control"
                                  v-model="data.cantidad_corregida" placeholder="cantidad"
                                  @change="calcularSubtotal(data)"
                              >
                            </div>
                          </td>
                          <td class="text-right">{{data.costo_unitario}}</td>
                          <td>

                            <div
                                class="input-group input-group-sm"
                                v-if="parseInt(data.estado)===3 && data.tipo_costo==='Costo indirecto'"
                            >
                              <input type="text" class="form-control"
                                     v-model="data.subtotal_corregido"
                                     placeholder="parcial"
                              >
                            </div>
                            <!--<div v-if="parseInt(data.estado)!==3">
                              {{data.subtotal_corregido}}
                            </div>-->
                            <div v-else>
                              {{data.subtotal_corregido}}
                            </div>
                          </td>

                          <!--<td>{{data.estado_str}}</td>-->
                          <td>
                            <select class="form-control-sm" v-model="data.estado" @change="cambiarEstado($event,index)" >
                              <option value="1">En revision</option>
                              <option value="2">Validado</option>
                              <option value="3">Observado</option>
                            </select>
                          </td>
                          <td>
                            <button class="btn btn-info btn-icon btn-sm mr-1" v-on:click="infoAvance(data.avance_id)" ><i class="fa fa-eye"></i></button>
                          </td>
                        </tr>
                        <tr v-bind:key="index.toString()+'F'" v-if="parseInt(data.estado)===3"  :class="{'table-light': index % 2 === 0 }">
                          <td></td>
                          <td></td>
                          <td class="text-right">Observacion:</td>

                          <td colspan="7">
                            <div class="input-group input-group-sm">
                              <input v-model="data.observacion"  class="form-control"/>
                            </div>

                          </td>
                        </tr>
                        <tr class="border-bottom"  v-bind:key="index.toString()+'G'"></tr>
                      </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

    import PartidaAvanceInfo from "@/components/partida-avance-info.vue";

    export default {
        name: "revisar-avance-partidas",
        components: {
          PartidaAvanceInfo

        },
        methods:{
          infoAvance(avance_id){
            this.isLoading=true;
            this.axios.get(process.env.VUE_APP_BACKEND + "/api/avance/"+avance_id)
                .then((response)=>{
                  this.partida_avance=response.data;
                  this.$bvModal.show("modalVerAvance");
                })
                .finally(()=>this.isLoading=false)
          },
          cambiarEstado($event,index){
            //console.log($event.target.value);
            //console.log($event.target.defaultValue);
            if(parseInt($event.target.value)===2 || parseInt($event.target.value)===1){
              this.data.partidas[index].cantidad_corregida=this.data.partidas[index].cantidad;
              this.data.partidas[index].subtotal_corregido=this.data.partidas[index].subtotal;
              this.data.partidas[index].observacion="";
            }
            //$event.cancel;
          },
          calcularSubtotal(row){
            if(row.tipo_costo=='Costo directo'){
              row.subtotal_corregido=row.cantidad_corregida*row.costo_unitario;
            }
            //console.log(row)
          }


        },
        props: {
            data:{
                type:Object
            }
        },
        data() {
            return {
              server:process.env.VUE_APP_BACKEND,
              partida_avance:{},
            }
        }
    }
</script>

<style scoped>

</style>